import * as React from 'react';
import clsx from 'clsx';
import { withStyles, WithStyles, generateStaticClassName, createStyles } from '@domonda/ui/styles';

const styles = createStyles({
  root: {},
});

interface Props {
  children: React.ReactNode;
}

export const menuItemClassName = generateStaticClassName('MenuItem');

const MenuItem: React.FC<Props & WithStyles<typeof styles>> = (props) => {
  const { children, classes } = props;
  return <li className={clsx(menuItemClassName, classes.root)}>{children}</li>;
};

const StyledMenuItem = withStyles(styles)(MenuItem);
export { StyledMenuItem as MenuItem };
